import React from "react"
import styled, { css } from "styled-components"

import ArrowizedLink from "../global/arrowized-link"

const size = {
  desktop: 1152,
  tablet: 950,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const StatementWrapper = styled.div`
  max-width: 1248px;
  padding: 0 48px;
  margin: 104px auto 96px;
  ${below.tablet`
    margin: 64px auto 0;
  `};
  ${below.mobile`
  padding: 0 24px;
  `}
`
const StatementContainer = styled.div`
  display: flex;
  ${below.tablet`flex-direction: column;`}
`
const Leadin = styled.div`
  flex: 0;
  min-width: 360px;
  padding-right: 48px;

  .lead-in {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-transform: uppercase;
    color: #75808f;
    margin-bottom: 0px;
  }

  h2 {
    font-family: "Source Sans Pro", sans-serif;
    font-weight: 500;
    font-size: 64px;
    line-height: 80px;

    strong {
      font-weight: 700;
      font-family: inherit;
    }
    ${below.tablet`
    font-size: 40px;
line-height: 56px;
margin-bottom: 24px;`}
    ${below.mobile`
fong-size: 32px;
line-height: 48px;`}
  }
`
const Statement = styled.div`
  flex: 1;
  margin-top: 0;
  ${below.tablet`margin-top: 0;`}
`
const ArrowizedWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  &.large {
    ${below.tablet`display: none;`}
  }
  &.small {
    display: none;
    margin-top: 0px;
    margin-bottom: 112px;
    ${below.tablet`display: block;`}
    ${below.mobile`margin-bottom: 64px;`}
  }
  ${below.mobile`margin: 0;`}
  a {
    position: relative;
    font-family: "Playfair Display", serif;
    font-size: 24px;
    line-height: 32px;
    color: var(--pacific-blue);
    ${below.mobile`font-size: 18px; line-height: 24px;`}
  }
  svg {
    stroke: var(--pacific-blue);
    width: 24px;
    height: auto;
    margin: 4px 0 0 24px;
    transition: 0.3s ease-in-out;

    ${below.tablet`width: 16px; margin-left: 12px;`}
  }
  div {
    min-width: 325px;
    ${below.tablet`min-width: 235px`}
  }
`

const WhyStatement = props => {
  return (
    <StatementWrapper>
      <StatementContainer>
        <Leadin>
          <div className="lead-in">{props.team ? "About us" : "About me"}</div>
          <h2 className="sans">
            Not what, but <strong>Why!</strong>
          </h2>
          <ArrowizedWrapper className="large">
            <ArrowizedLink
              linkTo={`/${props.slug}/contact/`}
              linkText={props.team ? "Contact us" : "Contact me"}
            />
          </ArrowizedWrapper>
        </Leadin>
        {props.slug === "bobgold" && (
          <Statement>
            <p>
              My goal is always to deliver the{" "}
              <span
                css={`
                  font-weight: 700;
                  color: #cd9b1b;
                `}
              >
                gold standard
              </span>
              ...
            </p>
            <p>
              My entire career and every experience have led me to where I am
              right now - I am truly in the right place, at the right time,
              doing what I was born to do. The Carolinas are my home - where I
              live, work, and have spent time in the community, with my family,
              for decades.
            </p>
            <p>
              I am blessed to be in a profession where I get to assist people
              and their families navigate their journey to homeownership and
              help them on their way to the American Dream. I pride myself as
              being the “voice in the wilderness” for those who need guidance,
              and for being a trusted source of information for all my clients,
              partners, and teammates. This trust that is placed in me is both
              humbling and personally rewarding.
            </p>
            <p>
              Life is so much better when you work with people you know, like,
              and trust. I believe in and strive to “Live a sermon daily, and if
              necessary, use words”. I respect that every individual is unique
              and has their own challenges and blessings in life and as such I
              try to be patient, kind, and understanding.
            </p>
          </Statement>
        )}
        {props.slug === "sherrismith" && (
          <Statement>
            <p>
              I have a rose bush that gets just
              <span
                css={`
                  font-weight: 700;
                  color: #c21e56;
                `}
              >
                {" "}
                one bloom{" "}
              </span>
              at some very odd times during the year.
            </p>
            <p>
              When my grandmother passed, and before her house was sold, we dug
              up one of her rose bushes, brought it back to our home, and
              planted it in our yard. Since then, we have moved four more times,
              and every time we bring this rose bush with us. Over the years,
              this rose bush has bloomed in February, December, and June with a
              single bloom—the same exact month that family members have passed
              away. It’s almost as if this rose bush tells us that our family
              members are okay.
            </p>
            <p>
              My satisfaction is working in my yard and seeing the roses and
              plants that were given to me by my grandmother and other family
              members over the years. Not only do I find comfort in these
              plants, but they are a wonderful sign of life. I have the honor of
              helping my clients obtain their own yards with the ability to
              plant, entertain, and design their own landscapes. I
              wholeheartedly dig in with care to help my clients! These may only
              be yards, but they are a huge part of what makes us who we are and
              how we feel on a daily basis.
            </p>
            <p>
              The same care I give to my roses is the same care I give to my
              clients—and I give my roses a lot of care!
            </p>
          </Statement>
        )}
        {props.slug !== "bobgold" && props.slug !== "sherrismith" && (
          <Statement
            dangerouslySetInnerHTML={{
              __html: props.whyStatement,
            }}
          />
        )}
      </StatementContainer>
      <ArrowizedWrapper className="small">
        <ArrowizedLink
          linkTo="/contact/"
          linkText={props.team ? "Contact us" : "Contact me"}
        />
      </ArrowizedWrapper>
    </StatementWrapper>
  )
}

export default WhyStatement
